module.exports = __webpack_public_path__ + "static/media/money-bills-simple.2dfebfc6.svg";